import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="careers-apply-bar"
// Mobile sticky "apply" bar that hides once the form is in (or above) view.
export default class extends Controller {
  static targets = ["bar", "form"];

  connect() {
    if (!this.hasBarTarget) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.barTarget.hidden =
          entry.isIntersecting || entry.boundingClientRect.top < 0;
      },
      { rootMargin: "0px 0px -80px 0px" },
    );
    this.observer.observe(this.formTarget);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  scrollToForm() {
    this.formTarget.scrollIntoView({ behavior: "smooth", block: "start" });
    this.formTarget
      .querySelector("input[autocomplete='name']")
      ?.focus({ preventScroll: true });
  }
}
